import { emptyStrIfNot } from '../../logic/utils.ts';
import { AsApp } from '../as-app.ts';
import { useShadow, useShadowStyle } from '../wcUtil.ts';
import styleText from './as-footer.css?raw';

class AsVersionTag extends HTMLElement{
  versions:{[key:string]:string|undefined}={
    app:undefined ,
    components:undefined,
    trcad:undefined,
    trcadScript:undefined
  }
  async getVersions(){
    return new Promise<void>(async (resolve,reject)=>{
      const appEl = document.querySelector("as-app") as AsApp
      const {components,app,trCad,trCadScript} = await appEl.getVersions()
      this.versions.app = app
      this.versions.components = components
      this.versions.trcad = trCad
      this.versions.trcadScript = trCadScript
      resolve()

    })
  }

  get html(){
    return /*html*/`
      <span id="version-tags">
        ${emptyStrIfNot(this.versions.app,`app v${this.versions.app}`)}
        ${emptyStrIfNot(this.versions.components,`| ASC v${this.versions.components}`)} 
        ${emptyStrIfNot(this.versions.trcadScript,`| script v${this.versions.trcadScript}`)} 
        ${emptyStrIfNot(this.versions.trcad,`| trCAD v${this.versions.trcad}`)} 
      </span>
  `
  }
  redraw(){
    if(this.shadowRoot){
      this.shadowRoot.innerHTML = this.html
    }
  }
  async connectedCallback(){
    useShadow(this)
    await useShadowStyle(this, styleText, './as-footer.css')
    await this.getVersions()
    this.redraw()
  }
}

export class AsFooter extends HTMLElement{

  get html(){
    return /*html*/`
      <as-version-tag></as-version-tag>
      <as-trinckle-label></as-trinckle-label>
  `
  }
  async connectedCallback(){
    useShadow(this)
    await useShadowStyle(this, styleText, './as-footer.css')
  }
}

customElements.define('as-version-tag', AsVersionTag)
customElements.define('as-footer', AsFooter)